<template>
  <div id="app">
    <loading-screen></loading-screen>
    <nav-bar></nav-bar>
    <router-view></router-view>
    <current-action></current-action>
    <errors></errors>
    <div class="contact" v-if="footerVisible">
      Crafted with ❤️ by <a href="mailto:damian@swistowski.org">DŚ</a>, <a
      href="https://github.com/dswistowski/itemmanager-issues/issues"><i class="fa fa-github"></i></a>
      <social-sharing url="https://itemmanager.uk/"
                      title="Item Manager for Destiny 2"
                      description="Item manager allows you transfer your items between characters with one click"
                      quote="The fastest item manager for Destiny 2."
                      hashtags="destiny,item,manager,vault"
                      twitter-user="itemmanager"
                      inline-template>
        <div class="shares">
          <network network="facebook">
            <i class="fa fa-facebook"></i>
          </network>
          <network network="googleplus">
            <i class="fa fa-google-plus"></i>
          </network>
          <network network="email">
            <i class="fa fa-envelope"></i>
          </network>
          <network network="reddit">
            <i class="fa fa-reddit"></i>
          </network>
          <network network="twitter">
            <i class="fa fa-twitter"></i>
          </network>
          <network network="whatsapp">
            <i class="fa fa-whatsapp"></i>
          </network>
        </div>
      </social-sharing>
      <i class="material-icons close" @click="footerVisible=false">close</i>
    </div>
  </div>
</template>

<script>
  import NavBar from '@/components/NavBar'
  import CurrentAction from '@/components/CurrentAction'
  import Errors from '@/components/Errors'
  import LoadingScreen from '@/components/LoadingScreen'
  import SocialSharing from 'vue-social-sharing'

  export default {
    name: 'app',
    computed: {},
    data () {
      return {
        footerVisible: true
      }
    },
    components: {
      NavBar,
      CurrentAction,
      Errors,
      LoadingScreen,
      SocialSharing
    }
  }
</script>

<style lang="scss">
  @import "styles/settings";
  @import url('//fonts.googleapis.com/css?family=Roboto:300,400,500');
  @import url('//fonts.googleapis.com/icon?family=Material+Icons');
  @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');

  html {
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  .container {
  }

  h1, h2, h3, h4, h5, h6 {
    color: rgba(255, 206, 31, .8);
    font-weight: 300;

  }

  h2 {
    font-size: 1rem;
  }

  a, .fa {
    color: rgba(245, 245, 245, 0.5);
    font-weight: 400;
    text-decoration: none;

    &:hover, &:focus {
      color: rgba(245, 245, 245, 1);
      cursor: pointer;
      text-decoration: none;
    }
  }

  body {
    margin: 0;
    background-color: $body-background;
    color: #f5f5f5;
    font-weight: 300;
    font-size: 13px;
    user-select: none;
    margin-bottom: 4rem;
  }

  .container {
    flex-grow: 1;
    flex-shrink: 1;
    overflow: scroll;
  }

  #app {
    font-family: 'Roboto', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .material-icons {
    font-size: 1rem;
    vertical-align: text-bottom;
  }

  @media only screen and (min-width: 640px) {
    .only-small {
      display: none
    }
  }

  @media #{$media-phone} {
    .only-big {
      display: none
    }
  }

  select {
    &:focus {
      outline: none
    }
    border: 0;
    font-size: 1em;
    padding: 0;
    background: rgba(0, 0, 0, 0);
    color: rgba(245, 245, 245, 0.5);
    text-transform: uppercase;
    font-weight: 600;
    cursor: pointer;
    transition: color 0.2s ease-in-out;
    &:hover {
      color: rgba(245, 245, 245, 1);
    }
  }

  .clickable {
    cursor: pointer
  }

  .shadow {
    box-shadow: $default-shadow;
  }

  .contact {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: .5rem;
    background: $background;;
    z-index: 100;
    font-size: 1rem;
    .shares {
      .fa, .a {
        padding-left: 0.3rem;
      }
      display: inline-block;
    }
    .close {
      &.material-icons {
        font-weight: bold;
        float: right;
        font-size: 1rem;
        cursor: pointer;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// App.vue?864e2ee6